// extracted by mini-css-extract-plugin
export var focusOnly = "numeric-input-module--focusOnly--G3KFH";
export var input = "numeric-input-module--input--aI96j";
export var notavailable = "numeric-input-module--notavailable--1WAcL";
export var smFont = "numeric-input-module--smFont--rNZav";
export var wrap = "numeric-input-module--wrap---fT8G";